// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"messages_buttonsContainer__1X32W","spacer":"messages_spacer__1lat_","label":"messages_label__avja4"};